import { createReducer } from 'redux-act';
import actionsFactory from 'magic/actionsFactory';

const createAction = actionsFactory('coachGroup/');

const initialState = {
  coaches: [],
  controlpersons: [],
  organization: {},
  players: [],
  season: null,
  shortName: '',
  stage: null,
  stageYear: '',
  yearBirth: [],
  loading: true,
};

// Добавление всяких данных
const setData = createAction('setData');

// Добавление тренеров
const setCoaches = createAction('setCoaches');

// Добавление футболистов
const setPlayers = createAction('setPlayers');

// Очистка всего стора
const clearData = createAction('clearData');

// Включаем прелоадер
const startLoading = createAction('startLoading');

// Отключаем прелоадер
const stopLoadingWithError = createAction('stopLoadingWithError');

const reducer = createReducer(
  {
    [startLoading]: (state) => ({
      ...state,
      loading: true,
    }),
    [stopLoadingWithError]: (state) => ({
      ...state,
      loading: false,
    }),
    [setData]: (state, payload) => ({
      ...state,
      ...payload,
      loading: false,
    }),
    [setPlayers]: (state, players) => ({
      ...state,
      players,
    }),
    [setCoaches]: (state, coaches) => ({
      ...state,
      coaches,
    }),
    // Очистка всего стора
    [clearData]: () => initialState,
  },
  initialState,
);

export default reducer;
